function quality_edit_save(event) {
    var reason_input_div = $('#reason_input_div');
    var approval_status_div = $('#approval_status_div');
    var inspection_status_div = $('#inspection_status_div');
    var inspection_id = $(event.target).data('inspectionId');
    var inspection_status = $('#inspection_status_' + inspection_id).val();
    var approval_status = $('#approval_status_' + inspection_id).val();
    var reason = $('#reason_' + inspection_id).val();
    var validated = true;

    //clear errors
    var error_messages = [];
    reason_input_div.removeClass('has-error');
    approval_status_div.removeClass('has-error');
    inspection_status_div.removeClass('has-error');

    //Reason must be selected
    if (reason === "0") {
        reason_input_div.addClass('has-error');
        error_messages.push('Please select a reason for the update.');
        validated = false;
    }

    // if insp status is hold then approval status should be hold as well
    if (inspection_status === 'HOLD' && approval_status !== 'HOLD') {
        approval_status_div.addClass('has-error');
        error_messages.push('To set to hold, please set both inspecton status and approval status to hold.');
        validated = false;
    }

    if (inspection_status !== 'HOLD' && approval_status === 'HOLD') {
        inspection_status_div.addClass('has-error');
        error_messages.push('To set to hold, please set both inspecton status and approval status to hold.');
        validated = false;
    }


    // inspection status set to complete then
    if (inspection_status === 'COMPLETE') {
        inspection_status_div.addClass('has-error');
        error_messages.push('Inspection status cannot be set as complete, please put it on hold.');
        validated = false;
    }

    if (validated) {
        $('#quality_edit_confirm_modal').modal('show');
        $('#quality_edit_confirm_modal_text').html('Inspection status will be set to ' + inspection_status +
            '<br> Approval status will be set to ' + approval_status +
            '<br> Selected reason for update is ' + $('#reason_' + inspection_id + ' option:selected').text());
    } else {
        var final_error_str = '';
        for (error_index in error_messages) {
            error_str = error_messages[error_index];
            final_error_str += '<li>' + error_str + '</li>';
        }
        $('#quality_edit_modal_error_ol').html(final_error_str);
    }
}

function quality_edit_confirm_modal_submit(event) {
    var inspection_id = $('#inspection_id').val();
    var username = $('#username').val();
    var inspection_status = $('#inspection_status_' + inspection_id).val();
    var approval_status = $('#approval_status_' + inspection_id).val();
    var reason = $('#reason_' + inspection_id).val();

    json_msg = {
        "inspection_id": inspection_id,
        "inspection_status_code": inspection_status,
        "approval_status_code": approval_status,
        "reason_code": reason,
        "username": username
    };

    UpdateInspection(json_msg); //This is found in summary.js
}

function comment_submit(event) {
    var inspection_id = $('#inspection_id').val();
    var username = $('#username').val();
    var comment_to_add = $('#add_comment_textarea').val();

    AddComment(inspection_id, comment_to_add, username, function (msg) { //function found in summary.js
        //Update just the comments panel for a better UX
        $.ajax({
            type: 'GET',
            url: "/inspections/detail-comments-panel/" + inspection_id,
        }).done(function (data, text_status, jqXHR) {
            $('#comments-table-rows-body').html(data);
            $('#add_comment_textarea').val('');
        });
    });
}


function change_history(event){
    var select_ele = event.target;
    var ele = $('#' + select_ele.id + ' option:selected');
    var inspection_id = ele.val();
    location.href='/inspections/detail/' + inspection_id;
}


function handle_detail_page_load() {
    var side_panel_image = $('#side-panel-main-image');

    $('.quality_edit_save').on("click", quality_edit_save);
    $('#quality_edit_confirm_modal_submit').on("click", quality_edit_confirm_modal_submit);

    $('.submit-comment').on('click', comment_submit);
    $('.submit-resend-inspection').on('click', resend_inspection);
    $('.submit-tech-review').on('click', tech_review);
    $('.inspection-history-select').on('change', change_history);
    $(document).trigger("enhance.tablesaw");
    // register inline function that passes the damage name to the modal

    if (side_panel_image.length) {
        side_panel_image.removeClass('invisible');
    }
}


function tech_review_modal_setup() {
  $('#modal_error').attr('class','hide');
  $('.tech-review-status-input').click(function() {
    $('.tech-review-status-input').removeAttr('style');
    review_status = $('.tech-review-status-input:checked').val();
  });
  $('#tech_review_modal').on('show.bs.modal', function(e) {
    // clear out previous entries in modal box.
    $('.tech-review-status-input').prop('checked', false);
    $("#modal_error").attr('class','hide');
    review_status = ''
    $('#tech_review_comment')[0].value = '';

    // set id of element clicked to modal to determine damage area or inspection level comment
    modal_id = $(e.relatedTarget).data('id');

    if(modal_id == 'inspection_level'){
        $('#tech_review_modal h4.modal-title')[0].textContent = 'Tech Review: Overall Tech Review';
        if($(e.relatedTarget).data('comment') == 'Per AiM Request' || $(e.relatedTarget).data('comment') == 'Per Customer Request'){
            $('#tr_comment')[0].textContent = 'Cancelled ' + $(e.relatedTarget).data('comment');
        }
        document.getElementById("radio_options").style.display = 'block';
    }else{
        $('#tech_review_modal h4.modal-title')[0].textContent = 'Tech Review: ' + modal_id;
        document.getElementById("radio_options").style.display = 'none';
    }
    $('#tr_reason_label')[0].textContent = 'Reason: ';
    $('#tr_reason')[0].textContent = $(e.relatedTarget).data('reason')

    $('#tr_comment')[0].textContent = $(e.relatedTarget).data('comment');


    // TODO: check for existing comment made by current user on selected damage
    // if exists then set default state of modal box and load comment.
  });
};


function tech_review() {
  var review_comment = $('#tech_review_comment').val();
  var inspection_id = $('#hidden_inspection_id').val();
  var username = $('#username').val();
  // validate data entered and display error messages in modal box if not.
  if (!review_status && modal_id === "inspection_level") { var error = 'Please select a status.' }
  else if (!review_comment) { var error = 'Please enter a comment.' }

  if (typeof error == 'undefined') {
    $('#modal_error').attr('class','hide');
  } else {
    $('#modal_error')[0].textContent = error;
    $('#modal_error').removeAttr('class');
    return
  }

  var msg = {
    area: modal_id,
    inspection_id: inspection_id,
    comment: review_comment,
    review_status: review_status,
    username: username
  }
  $("body").css("cursor", "progress");
  $('#tech_review_modal').modal('hide')
  $.ajax({
    method: "POST",
    url: "/inspections/tech-review",
    data: JSON.stringify(msg)
  }).done(function (data, textStatus, jqXHR) {
    console.log('Successful ajax response: ' + JSON.stringify(msg));
    Snackbar.show({
      text: "Tech review updated",
      duration: 2000,
      showAction: false
    });
    location.reload();
  }).fail(function(jqXHR, textStatus, errorThrown){
      var response_errors = jqXHR.hasOwnProperty('responseJSON') ? jqXHR.responseJSON['errors']  : null;
      var error = response_errors ? response_errors : errorThrown;
      var error_msg = error_msg = "There was an error. Comment was not submitted. " + error;
      if (error == 'Conflict'){
        error_msg = "This tech review has already been responded to.";
      }
      Snackbar.show({
          text: error_msg,
          duration: 2000,
          showAction: false
      });

      console.error(error_msg + JSON.stringify(msg));
      location.reload();
  }).always(function(jqXHR, textStatus, errorThrown){
      $("body").css("cursor", "default");
  });
}

function resend_inspection(event) {
    var inspection_id = $('#hidden_inspection_id').val();
    var username = $('#username').val();
    var json_msg = {
        id: inspection_id,
        user: username
    };
    $("body").css("cursor", "progress");
    $.ajax({
        method: "POST",
        url: "/inspections/resend-inspection",
        data: JSON.stringify(json_msg)
    }).done(function (data, textStatus, jqXHR) {
        console.log('successful ajax response: ' + data);
        Snackbar.show({
            text: "Successfully resent inspection",
            duration: 2000,
            showAction: false
        });
    }).fail(function(jqXHR, textStatus, errorThrown){
        var response_errors = jqXHR.hasOwnProperty('responseJSON') ? jqXHR.responseJSON['errors']  : null;
        var error = response_errors ? response_errors : errorThrown;
        var error_msg = "There was an error. " + error;
        Snackbar.show({
            text: error_msg,
            duration: 2000,
            showAction: false
        });

        console.error(error_msg + JSON.stringify(json_msg));
    }).always(function(jqXHR, textStatus, errorThrown){
        $("body").css("cursor", "default");
    });
}

function handle_detail_page_resize() {
    var side_panel_image = $('#side-panel-main-image');

    if (side_panel_image.length) {
        side_panel_image.css('max-height', $(window).height() / 3);

        if ($(document).width() > 992) {
            var side_panel_nav = $('#vehicle-navigation-buttons-div');
            var side_panel_data_div = $('#vehicle-side-panel-data-div');
            var panel_div = $('#vehicle-side-panel-data-div div.panel');

            if (side_panel_data_div[0].scrollHeight >= $(window).height() * .95) {
                side_panel_data_div.css('height', $(window).height() * .85);
                side_panel_data_div.css('overflow-y', 'scroll');
                panel_div.css('margin-bottom', 0);

                if (navigator.platform.indexOf('Mac') > -1) {
                    side_panel_data_div.addClass('show-scrollbar');
                }

                side_panel_nav.css('padding', '20px 10px');
                side_panel_nav.css('margin-left', '5px');

                $(".vehicle-navigation-buttons-jump").css("font-size", "14px");
                $(".vehicle-navigation-button-label").css("font-size", "10px");
                side_panel_nav.find(".mt20").addClass("mt10").removeClass("mt20");
            } else {
                side_panel_data_div.css('height', "").css('overflow-y', "");
                side_panel_data_div.removeClass('show-scrollbar');
                panel_div.css('margin-bottom', "");
                side_panel_nav.css('padding', "");
                side_panel_nav.css('margin-left', "");

                $(".vehicle-navigation-buttons-jump").css("font-size", "");
                $(".vehicle-navigation-button-label").css("font-size", "");
                side_panel_nav.find(".mt10").addClass("mt20").removeClass("mt10");
            }
        }
    }
}

//This activates after images are loaded
$(function () {
  handle_detail_page_load();
  handle_detail_page_resize();
  tech_review_modal_setup();
  var initPhotoSwipeFromDOM = function(gallerySelector) {

      // parse slide data (url, title, size ...) from DOM elements 
      // (children of gallerySelector)
      var parseThumbnailElements = function(el) {
          var thumbElements = el.childNodes,
              numNodes = thumbElements.length,
              items = [],
              figureEl,
              linkEl,
              size,
              item;

          for(var i = 0; i < numNodes; i++) {

              figureEl = thumbElements[i]; // <figure> element

              // include only element nodes 
              if(figureEl.nodeType !== 1) {
                  continue;
              }

              linkEl = figureEl.children[0]; // <a> element

              // size = linkEl.getAttribute('data-size').split('x');
        
              // create slide object
              item = {
                  src: linkEl.getAttribute('href'),
                  w: parseInt(document.getElementById('picture').getElementsByTagName('img')[0].naturalWidth, 10),
                  h: parseInt(document.getElementById('picture').getElementsByTagName('img')[0].naturalHeight, 10)
              };



              if(figureEl.children.length > 1) {
                  // <figcaption> content
                  item.title = figureEl.children[1].innerHTML; 
              }

              if(linkEl.children.length > 0) {
                  // <img> thumbnail element, retrieving thumbnail url
                  item.msrc = linkEl.children[0].getAttribute('src');
              } 

              item.el = figureEl; // save link to element for getThumbBoundsFn
              items.push(item);
          }

          return items;
      };

      // find nearest parent element
      var closest = function closest(el, fn) {
          return el && ( fn(el) ? el : closest(el.parentNode, fn) );
      };

      // triggers when user clicks on thumbnail
      var onThumbnailsClick = function(e) {
          e = e || window.event;
          e.preventDefault ? e.preventDefault() : e.returnValue = false;

          var eTarget = e.target || e.srcElement;

          // find root element of slide
          var clickedListItem = closest(eTarget, function(el) {
              return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
          });

          if(!clickedListItem) {
              return;
          }

          // find index of clicked item by looping through all child nodes
          // alternatively, you may define index via data- attribute
          var clickedGallery = clickedListItem.parentNode,
              childNodes = clickedListItem.parentNode.childNodes,
              numChildNodes = childNodes.length,
              nodeIndex = 0,
              index;

          for (var i = 0; i < numChildNodes; i++) {
              if(childNodes[i].nodeType !== 1) { 
                  continue; 
              }

              if(childNodes[i] === clickedListItem) {
                  index = nodeIndex;
                  break;
              }
              nodeIndex++;
          }



          if(index >= 0) {
              // open PhotoSwipe if valid index found
              openPhotoSwipe( index, clickedGallery );
          }
          return false;
      };

      // parse picture index and gallery index from URL (#&pid=1&gid=2)
      var photoswipeParseHash = function() {
          var hash = window.location.hash.substring(1),
          params = {};

          if(hash.length < 5) {
              return params;
          }

          var vars = hash.split('&');
          for (var i = 0; i < vars.length; i++) {
              if(!vars[i]) {
                  continue;
              }
              var pair = vars[i].split('=');  
              if(pair.length < 2) {
                  continue;
              }           
              params[pair[0]] = pair[1];
          }

          if(params.gid) {
              params.gid = parseInt(params.gid, 10);
          }

          return params;
      };

      var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
          var pswpElement = document.querySelectorAll('.pswp')[0],
              gallery,
              options,
              items;

          items = parseThumbnailElements(galleryElement);

          // define options (if needed)
          options = {

              // define gallery index (for URL)
              galleryUID: galleryElement.getAttribute('data-pswp-uid'),

              getThumbBoundsFn: function(index) {
                  // See Options -> getThumbBoundsFn section of documentation for more info
                  var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                      pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                      rect = thumbnail.getBoundingClientRect(); 

                  return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
              }

          };

          // PhotoSwipe opened from URL
          if(fromURL) {
              if(options.galleryPIDs) {
                  // parse real index when custom PIDs are used 
                  // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                  for(var j = 0; j < items.length; j++) {
                      if(items[j].pid == index) {
                          options.index = j;
                          break;
                      }
                  }
              } else {
                  // in URL indexes start from 1
                  options.index = parseInt(index, 10) - 1;
              }
          } else {
              options.index = parseInt(index, 10);
          }

          // exit if index not found
          if( isNaN(options.index) ) {
              return;
          }

          if(disableAnimation) {
              options.showAnimationDuration = 0;
          }

          // Pass data to PhotoSwipe and initialize it
          gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
          gallery.init();
      };

      // loop through all gallery elements and bind events
      var galleryElements = document.querySelectorAll( gallerySelector );

      for(var i = 0, l = galleryElements.length; i < l; i++) {
          galleryElements[i].setAttribute('data-pswp-uid', i+1);
          galleryElements[i].onclick = onThumbnailsClick;
      }

      // Parse URL and open gallery if it contains #&pid=3&gid=1
      var hashData = photoswipeParseHash();
      if(hashData.pid && hashData.gid) {
          openPhotoSwipe( hashData.pid ,  galleryElements[ hashData.gid - 1 ], true, true );
      }
  };
  initPhotoSwipeFromDOM('.image_gallery');
});
$(window).on("resize", debounce(handle_detail_page_resize, 200));
